import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';

import { history } from '../../../_services/essentials/helpers';
import { inquiriesActions, alertActions, breadcrumbsActions } from '../../../_services/essentials/store';
import { TextField, Button, Stack, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import Typography from "@mui/material/Typography";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import CancelIcon from "@mui/icons-material/Cancel";
import { ArrowForwardOutlined } from '@mui/icons-material';

import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
const Card = styled(MuiCard)(({ theme }) => ({
    padding: theme.spacing(3),
    gap: theme.spacing(2),
    margin: 'auto',
    borderRadius: '8px', // Rounded corners
    background: 'var(--Neutral-White, #FFF)', // Background color
    boxShadow: '0px 12px 26px 0px rgba(16, 30, 115, 0.06)', // Floating shadow
    [theme.breakpoints.up('sm')]: {
        width: '30%',
    },
}));

export { AddEdit };

function AddEdit() {

    const entities = 'inquiries';

    const { id } = useParams();
    const entity_label = "Inquiry";

    const dispatch = useDispatch();
    const entity = useSelector(x => x.inquiries?.item);
    //const communication_modes = useSelector(x => x.inquiries?.communication_modes);
    const inquiry_types = useSelector(x => x.inquiries?.inquiryTypes);
    const loggedInUser = useSelector(x => x.auth.loggedInUser);

    // form validation rules

    const validationSchema = Yup.object().shape({

        // in_full_name: Yup.string()
        //     .trim()
        //     .required('Required*')
        //     .max(60, 'Cannot exceed 60 characters'),
        // in_email_address: Yup.string()
        //     .trim().email("Please enter a valid Email")
        //     .required('Required*')
        //     .max(60, 'Cannot exceed 60 characters'),
        // in_phone_number: Yup.string()
        //     .trim()
        //     .matches(
        //         /^[0-9]+$/,
        //         'Please enter a valid Phone number'
        //     ),
        // // in_preferred_contact_method: Yup.string()
        // //     .matches(
        // //         /[-][S][e][l][e][c][t][-]/,
        // //     'Required*',
        // //     ),
        // in_company_name: Yup.string()
        //     .trim()
        //     .required('Required*')
        //     .max(60, 'Cannot exceed 60 characters'),
        // in_company_website: Yup.string()
        //     .url("Please enter a valid URL (http://www.kypl.com)")
        //     .required('Required*')
        //     .max(60, 'Cannot exceed 60 characters'),
        // in_inquiry_details: Yup.string()
        //     .trim()
        //     .required('Required*')
        //     .max(60, 'Cannot exceed 60 characters'),
        in_inquiry_description: Yup.string()
            .trim()
            .required('Required*')
            .max(250, 'Cannot exceed 250 characters'),
        in_geographic_scope: Yup.string()
            .trim()
//            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
        in_keyword_or_therapeutic_area: Yup.string()
            .trim()
  //          .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, reset, formState, control } = useForm(formOptions);
    const { errors } = formState;

    dispatch(breadcrumbsActions.setCurrentURL({
        url: history.location?.pathname,
        state: history.location?.state
    }));

    useEffect(() => {
        dispatch(breadcrumbsActions.setCurrentTitle(`Inquiry`));
        if (id) {
            // fetch user details into redux state and
            // populate form fields with reset()
            dispatch(inquiriesActions.getById(id)).unwrap()
                .then(entity => {
                    reset(entity);
                    //      setUserValue(user);
                });

        } else {
            // const newEntity = {
            //     firstname_of_the_account: loggedInUser?.firstname,
            //     lastname_of_the_account: loggedInUser?.lastname,
            //     email_address_of_the_account: loggedInUser?.email,
            //     in_full_name: `${loggedInUser?.firstname} ${loggedInUser?.lastname}`,
            //     in_email_address: loggedInUser?.email,
            //     in_phone_number: loggedInUser?.phone,
            //     in_preferred_contact_method: "Email",
            //     in_company_name: loggedInUser?.customer.organizationName,
            //     in_company_website: loggedInUser?.customer.websiteURL,
            //     in_inquiry_details: "",
            //     in_inquiry_description: "",
            //     in_additional_comments_or_questions: "",
            //     in_keyword_or_therapeutic_area: "",
            //     in_geographic_scope: ""
            // };
            const newEntity = {
                firstname_of_the_account: loggedInUser?.firstname,
                lastname_of_the_account: loggedInUser?.lastname,
                email_address_of_the_account: loggedInUser?.email,
                in_full_name: `${loggedInUser?.firstname} ${loggedInUser?.lastname}`,
                in_email_address: loggedInUser?.email,
                in_phone_number: loggedInUser?.phone,
                //in_preferred_contact_method: "Email",
                in_company_name: loggedInUser?.customer.organizationName,
                in_company_website: loggedInUser?.customer.websiteURL,
                //in_inquiry_details: "",
                in_inquiry_type: "New Request",
                in_inquiry_description: "",
                //in_additional_comments_or_questions: "",
                in_keyword_or_therapeutic_area: "",
                in_geographic_scope: ""
            };
            dispatch(inquiriesActions.getNewEntity(newEntity)).unwrap()
                .then(entity => {
                    reset(entity);
                    //      setUserValue(user);
                });
        }
    }, [id, dispatch, reset, loggedInUser]);

    useEffect(() => {
        //dispatch(inquiriesActions.getAllCommunicationModes());
        dispatch(inquiriesActions.getAllInquiryTypes());
    }, [dispatch]);


    async function onSubmit(data) {
        dispatch(alertActions.clear());
        try {
            // create or update user based on id param
            let message;
            dispatch(alertActions.success({ message: "Please wait for a moment...", showAfterRedirect: false }));
            const response = await dispatch(inquiriesActions.create({ data })).unwrap();
            message = response.message;
            dispatch(alertActions.success({ message, showAfterRedirect: false }));
            reset();
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    return (
        <React.Fragment>
            <Card sx={{
                ml: 2
            }}>
                <Stack
                    sx={{

                        justifyContent: 'space-between', flexGrow: '1', gap: 1
                    }}
                >
                    {/* <Typography component="h2" variant="h6" sx={{ mb:1.5 }}>
                    {entity_label}
                </Typography> */}
                    {!(entity?.loading || entity?.error) &&
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }}>
                                <Stack direction="row" sx={{ flexGrow: '0', ml:5 }} >
                                    <TextField
                                        id="firstname_of_the_account"
                                        name="firstname_of_the_account"
                                        hidden
                                        value={`${entity?.value?.firstname_of_the_account}`}
                                    />
                                    <TextField
                                        id="lastname_of_the_account"
                                        name="lastname_of_the_account"
                                        hidden
                                        value={`${entity?.value?.lastname_of_the_account}`}
                                    />
                                    <TextField
                                        id="email_address_of_the_account"
                                        name="email_address_of_the_account"
                                        hidden
                                        value={`${entity?.value?.email_address_of_the_account}`}
                                    />
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', ml:5, gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Inquiry Type<span style={{ color: 'red' }}>*</span></Typography>
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', ml:5, gap: 1 }} >
                                    {!(inquiry_types?.loading || inquiry_types?.error) &&
                                        <FormControl fullWidth>
                                            {/* <InputLabel id="select-communication_modes-label">Preferred Contact Method</InputLabel> */}

                                            <Controller
                                                name="in_inquiry_types"
                                                control={control}
                                                defaultValue={entity?.value?.in_inquiry_type}
                                                {...register('in_inquiry_type')}
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        labelId="select-inquiry_types-label"
                                                        id="in_inquiry_types"
                                                        name="in_inquiry_types"
                                                        sx={{
                                                            mb: 1.5, border: 0, height: '40px', maxWidth: '350px', backgroundColor: '#fff', '&:hover': {
                                                                backgroundColor: '#fff'
                                                            },
                                                        }}
                                                    >
                                                        {/*<MenuItem key={-1} value={-1}>*/}
                                                        {/*    -Select-*/}
                                                        {/*</MenuItem>*/}
                                                        {inquiry_types?.value?.map((inquiryType) => (
                                                            <MenuItem key={inquiryType.name} value={inquiryType.name}>{inquiryType.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                )}
                                            />
                                        </FormControl>
                                    }
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', ml:5, gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Inquiry Description<span style={{ color: 'red' }}>*</span></Typography>
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', ml:5, gap: 1 }} >
                                    <TextField
                                        id="in_inquiry_description"
                                        name="in_inquiry_description"
                                        variant='outlined'
                                        color='primary'
                                        // label="Inquiry Description"
                                        placeholder={""}
                                        autoComplete="off"
                                        fullWidth
                                        multiline
                                        size="small"
                                        rows={3}
                                        sx={{
                                            mb: 1.5,
                                            '& .MuiInputBase-root': {
                                                height: 'auto',
                                                // maxWidth: '97%'
                                            },
                                        }}
                                        inputlabelprops={{ shrink: true }}
                                        defaultValue={entity?.value?.in_inquiry_description}
                                        {...register('in_inquiry_description', { required: true })}
                                        error={Boolean(errors.in_inquiry_description)}
                                        helperText={errors.in_inquiry_description ? errors.in_inquiry_description.message : ""}
                                        inputProps={{
                                            maxLength: 250,
                                        }}
                                    />
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', ml:5, gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Keyword or Therapeutic Area</Typography>
                                </Stack>
                                <Stack direction="column" sx={{ flexGrow: '1', ml:5, gap: 1 }} >
                                    <TextField
                                        id="in_keyword_or_therapeutic_area"
                                        name="in_keyword_or_therapeutic_area"
                                        type="text"
                                        variant='outlined'
                                        color='primary'
                                        // label="Keyword or Therapeutic Area"
                                        placeholder={""}
                                        autoComplete="off"
                                        fullWidth
                                        sx={{ mb: 1.5 }}
                                        inputlabelprops={{ shrink: true }}
                                        defaultValue={entity?.value?.in_keyword_or_therapeutic_area}
                                        {...register('in_keyword_or_therapeutic_area')}
                                        error={Boolean(errors.in_keyword_or_therapeutic_area)}
                                        helperText={errors.in_keyword_or_therapeutic_area ? errors.in_keyword_or_therapeutic_area.message : ""}
                                        inputProps={{
                                            maxLength: 60,
                                        }}
                                    />
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', ml:5, gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Geographic Scope</Typography>
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', ml:5, gap: 1 }} >
                                    <TextField
                                        id="in_geographic_scope"
                                        name="in_geographic_scope"
                                        type="text"
                                        variant='outlined'
                                        color='primary'
                                        // label="Geographic Scope"
                                        placeholder={""}
                                        autoComplete="off"
                                        fullWidth
                                        sx={{ mb: 1.5 }}
                                        inputlabelprops={{ shrink: true }}
                                        defaultValue={entity?.value?.in_geographic_scope}
                                        {...register('in_geographic_scope')}
                                        error={Boolean(errors.in_geographic_scope)}
                                        helperText={errors.in_geographic_scope ? errors.in_geographic_scope.message : ""}
                                        inputProps={{
                                            maxLength: 60,
                                        }}
                                />
                                </Stack>
                                <Stack direction="row" spacing={2} sx={{ mt: 3, ml:1 }} >
                                    <Button type={"submit"} variant="contained" size="small" endIcon={<ArrowForwardOutlined />}>
                                        Send Inquiry
                                    </Button>
                                    <Button onClick={() => reset()} variant="outlined" size="small" endIcon={<SettingsBackupRestoreIcon />}>
                                        Reset
                                    </Button>
                                    <Button onClick={() => history.navigate(-1)} variant="outlined" size="small" endIcon={<CancelIcon />}>
                                        Cancel
                                    </Button>
                                </Stack>
                            </Stack>
                        </form>
                    }
                </Stack>
            </Card>
        </React.Fragment>
    );
}
